import CoreAppService from '../_shared/api/coreAppService';
import TransactionRouterService from '../_shared/api/transactionRouterService';
import Singleton from '../Singleton';
import { PaymentOnHoldDocumentType } from '../global.d';

export default class PaymentsOnHoldService extends Singleton<
  PaymentsOnHoldService
> {
  /**
   * Public Methods
   */
  static fetchUploadedSellerFundingDocs = async (
    tradeId: number,
    documentType: number
  ) => {
    if (!tradeId) {
      return null;
    }
    const client = await CoreAppService();
    const paymentOnHoldUploadDocResponse = await client.paymentsOnHold.fetchPaymentOnHoldDocuments(
      documentType,
      tradeId
    );

    return paymentOnHoldUploadDocResponse?.data;
  };

  static removePaymentOnHoldDoc = async (documentId: number) => {
    if (!documentId) {
      return null;
    }
    const client = await CoreAppService();
    const paymentOnHoldRemoveDocResponse = await client.paymentsOnHold.deletePaymentOnHoldDocument(
      documentId
    );

    return paymentOnHoldRemoveDocResponse;
  };

  static submitSellerFundingDocs = async (
    tradeId: number,
    documentType: number,
    vin: string
  ) => {
    if (!tradeId || !vin) {
      return null;
    }
    const client = await CoreAppService();
    const paymentOnHoldSubmitDocResponse = await client.paymentsOnHold.submitPaymentOnHoldDocuments(
      {
        tradeId,
        documentType,
        vin
      }
    );

    return paymentOnHoldSubmitDocResponse;
  };

  static submitEtrSellerFundingDoc = async (
    purchaseId: string,
    documentType: PaymentOnHoldDocumentType,
    key: string
  ) => {
    if (!purchaseId || !documentType || !key) {
      return null;
    }

    const client = await TransactionRouterService();
    const response = await client.api.postPaymentOnHoldPurchaseIdDocuments(
      purchaseId,
      { documentType, key }
    );

    return response;
  };
}
